/* Bundle navigation analytics. No customer data; never delays navigation. */
(() => {
  if (window.pirBundleTrackingLoaded) return;
  window.pirBundleTrackingLoaded = true;
  const seen = new WeakSet();
  const visible = new Set();
  function publish(name, widget, extra = {}) {
    try {
      if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) return false;
      if (typeof window.Shopify?.analytics?.publish !== 'function') return false;
      const result = window.Shopify.analytics.publish('pir:' + name, {
        source_product: widget.dataset.sourceProduct,
        source_product_id: widget.dataset.sourceProductId,
        relationship: widget.dataset.relationship,
        placement: 'below_add_to_cart',
        theme_preview: widget.dataset.themePreview === 'true',
        ...extra
      });
      if (result?.catch) result.catch(() => {});
      return true;
    } catch (_) { return false; }
  }
  function recordViews() {
    if (document.visibilityState !== 'visible') return;
    visible.forEach(widget => {
      if (!seen.has(widget) && publish('bundle_widget_view', widget)) seen.add(widget);
    });
  }
  const observer = typeof IntersectionObserver === 'function'
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const widget = entry.target.closest?.('[data-pir-bundle-widget]') || entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) visible.add(widget);
          else visible.delete(widget);
        });
        recordViews();
      }, { threshold: [0, 0.5] }) : null;
  function initialize() {
    // Observe the heading so long assortments can register on small screens too.
    document.querySelectorAll('[data-pir-bundle-widget]').forEach(widget => observer?.observe(widget.querySelector?.('h2') || widget));
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a');
    if (!link) return;
    const widget = document.querySelector('[data-pir-bundle-widget]');
    if (!widget) return;
    if (link.matches('.pir-bundle-jump')) {
      publish('bundle_options_click', widget, { placement: 'near_price' });
    } else if (widget.contains(link) && link.dataset.destinationProduct) {
      publish('bundle_product_click', widget, {
        destination_product: link.dataset.destinationProduct,
        destination_product_id: link.dataset.destinationProductId,
        destination_variant_id: link.dataset.destinationVariantId || '',
        color: link.dataset.color || ''
      });
    }
  });
  document.addEventListener('visitorConsentCollected', recordViews);
  document.addEventListener('visibilitychange', recordViews);
  document.addEventListener('shopify:section:load', initialize);
  initialize();
})();
